import React from 'react'
import { ExpertReferralProgramForm } from '@expert/routes/ExpertReferralProgramForm'
import { Card, CARD_ELEVATION, CARD_PADDING_SIZE } from 'components/Card'
import { Flex } from 'components/Layout'

export const ExpertReferralWidget = () => (
  <Card
    flexDirection="column"
    width="100%"
    elevation={CARD_ELEVATION.NONE}
    hasBorders
    paddingSize={CARD_PADDING_SIZE.NONE}
  >
    <Flex flexDirection="column">
      <ExpertReferralProgramForm />
    </Flex>
  </Card>
)
